import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  collection,
  onSnapshot,
  updateDoc,
  deleteDoc,
  serverTimestamp
} from 'firebase/firestore';
import {
  getStorage,
  ref,
  uploadString,
  getDownloadURL,
  deleteObject
} from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD5jnFZ1-9-t5L7HRBXm9PgzL4hUDsjbg4",
  authDomain: "cs-poc-olb06ddayhymljadnl0sfwy.firebaseapp.com",
  projectId: "cs-poc-olb06ddayhymljadnl0sfwy",
  storageBucket: "cs-poc-olb06ddayhymljadnl0sfwy.firebasestorage.app",
  messagingSenderId: "702001264707",
  appId: "1:702001264707:web:be9e047f2cdf57f863fcf6"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export {
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  doc,
  setDoc,
  getDoc,
  collection,
  onSnapshot,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  ref,
  uploadString,
  getDownloadURL,
  deleteObject
};